import {UseQueryResult} from "react-query/types/react/types";
import {Client, CompressorPropertyWithValue} from "../../autogenerate/api.generated.clients";
import {useQuery} from "react-query";

interface UseBearingTempsProps {
    frameSerialNumber: string;
};

function useBearingTemps(props: UseBearingTempsProps): UseQueryResult<CompressorPropertyWithValue[]> {
    return useQuery(['bearingTemps', props.frameSerialNumber], ()=> new Client().bearing_GetBearingTemperatures(props.frameSerialNumber));
}

export default useBearingTemps;